import { SiteBrand } from "@/data/brand"
import { MCU } from "@/data/marvel"
import { DataTable, type Filter } from "@/modules/DataTable"
import { LayoutMain } from "@/modules/layout/main"
import {
	type TableColumn,
	type TableSort,
	TableSortDirection,
} from "@/modules/Table"

const columns: TableColumn<MCU.Entry>[] = [
	{
		display: (x) => {
			return x.Title
		},
		name: "Title",
	},

	{
		display: (row: MCU.Entry) => {
			if (!row.Released) {
				return "TBD"
			}
			let label = row.Released.getFullYear().toString()
			if (row.Released >= new Date()) {
				label = row.Released.toLocaleDateString()
			}

			return <span title={row.Released.toLocaleDateString()}>{label}</span>
		},
		name: "Released",
		sortFunction: (a, b) => {
			const valueA = a.Released || new Date("4000-01-01")
			const valueB = b.Released || new Date("4000-01-01")

			return valueA > valueB ? 1 : -1
		},
	},
	{
		display: (x) => {
			return x.Saga
		},
		name: "Saga",
	},
	{
		display: (x) => {
			return x.Phase
		},
		name: "Phase",
	},
	{
		display: (x) => {
			return x.Type
		},
		name: "Type",
	},
]

const defaultSort: TableSort = {
	columnIndex: 1,
	direction: TableSortDirection.DESC,
}

const filters: Record<string, Filter<MCU.Entry>> = {
	phase: {
		defaults: Object.values(MCU.Phase),
		filter: (row: MCU.Entry, selectedValues: string[]): boolean => {
			return selectedValues.includes(row.Phase)
		},
		label: "Phases",
		options: MCU.Phase,
	},
	saga: {
		defaults: Object.values(MCU.Saga),
		filter: (row: MCU.Entry, selectedValues: string[]): boolean => {
			return selectedValues.includes(row.Saga)
		},
		label: "Sagas",
		options: MCU.Saga,
	},
	types: {
		defaults: Object.values(MCU.Type),
		filter: (row: MCU.Entry, selectedValues: string[]): boolean => {
			return selectedValues.includes(row.Type)
		},
		label: "Types",
		options: MCU.Type,
	},
}

export const PageMarvel = () => {
	return (
		<LayoutMain Brand={SiteBrand}>
			<h1>Marvel</h1>
			<DataTable
				columns={columns}
				data={MCU.Entries}
				defaultSort={defaultSort}
				filters={filters}
			/>
		</LayoutMain>
	)
}
